module.exports = __webpack_public_path__ + "static/media/022.571d6903.jpg";